var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.page)?_c('elem',{attrs:{"mode":_vm.page,"root":true}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }